// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuItem_root__1n3fI"};